import { render, staticRenderFns } from "./modalCanjearRecompensa.vue?vue&type=template&id=72e297cc&scoped=true&"
import script from "./modalCanjearRecompensa.vue?vue&type=script&lang=js&"
export * from "./modalCanjearRecompensa.vue?vue&type=script&lang=js&"
import style0 from "./modalCanjearRecompensa.vue?vue&type=style&index=0&id=72e297cc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e297cc",
  null
  
)

export default component.exports